import { IDataEventsClient } from "@multiweb/clients/dataEvents";
import { ISectionLogger } from "@multiweb/logging";
import { isVersionOlderOrEqual } from "Global/Base/Utils/versionUtils";
import { DataEventsClient } from "./DataEventsClient";

export function defaultFactory(communicationUrl: string, webServiceVersion: string, logger: ISectionLogger): IDataEventsClient {
    return new DataEventsClient(logger, communicationUrl, undefined, isVersionOlderOrEqual(webServiceVersion, "15.03"));
}
